export default __webpack_public_path__ + "assets/Picture4.jpg";